import type Paginated from 'app/core/paginable';
import httpApiApplication from 'app/http/httpApiApplication';

import type { CatalogValue } from './Catalog/models/catalogValue.model';
import type {
  CatalogValueEditable,
  CatalogValueTranslation
} from './Catalog/models/catalogValueEditable.model';
import { type CatalogTypeModel } from './CatalogType/models/types';
export const baseUrlCatalogTypes = 'catalogs';
export const baseCatalogUrl = 'catalog-values';
class CatalogService {
  baseCatalogUrl() {
    return baseCatalogUrl;
  }
  baseCatalogTypeUrl(): string {
    return baseUrlCatalogTypes;
  }
  CatalogTypesListPaging(
    page: number,
    pageSize: number,
    params: any = undefined
  ): Promise<Paginated<CatalogTypeModel>> {
    return httpApiApplication.paginate<CatalogTypeModel>(
      baseUrlCatalogTypes,
      page,
      pageSize,
      params
    );
  }
  CatalogTypesList(): Promise<Array<CatalogTypeModel>> {
    return httpApiApplication.get(baseUrlCatalogTypes + '/all');
  }
  catalogList(type?: string): Promise<Array<CatalogValue>> {
    return httpApiApplication.get(baseCatalogUrl + '/' + type);
  }
  catalogType(id?: string, ignoreDefaultLang = false): Promise<CatalogTypeModel> {
    return httpApiApplication.get(baseUrlCatalogTypes + '/' + id, {
      headers: ignoreDefaultLang ? { lang: true } : undefined
    });
  }
  catalogTypeById(id?: string): Promise<CatalogTypeModel> {
    return httpApiApplication.get(baseUrlCatalogTypes + '/id/' + id);
  }
  langList(): Promise<Array<string>> {
    return httpApiApplication.get(baseCatalogUrl + '/langs');
  }
  CatalogListPaging(
    page: number,
    pageSize: number,
    params: any = undefined,
    type: string
  ): Promise<Paginated<CatalogValueEditable>> {
    // params = { includes: 'Type' };
    return httpApiApplication.paginate<CatalogValueEditable>(
      baseCatalogUrl + '/' + type + '/paginated',
      page,
      pageSize,
      params
    );
  }
  CreateCatalogType(values?: CatalogTypeModel) {
    return httpApiApplication
      .post(baseUrlCatalogTypes, values)
      .then((response) => ({ response }))
      .catch((error) => ({ error }));
  }
  UpdateCatalogType(values: CatalogTypeModel, id?: string) {
    return httpApiApplication
      .put(baseUrlCatalogTypes + '/' + id, values)
      .then((response) => ({ response }))
      .catch((error) => ({ error }));
  }
  CreateCatalog(values?: CatalogValueEditable) {
    return httpApiApplication
      .post(baseCatalogUrl, values)
      .then((response) => ({ response }))
      .catch((error) => ({ error }));
  }
  UpdateCatalog(values: CatalogValueEditable, id?: string) {
    return httpApiApplication
      .put(baseCatalogUrl + '/' + id, values)
      .then((response) => ({ response }))
      .catch((error) => ({ error }));
  }

  DeleteCatalog(id: string) {
    return httpApiApplication
      .delete(baseCatalogUrl + '/' + id)
      .then((response) => ({ response }))
      .catch((error) => ({ error }));
  }

  UpsertCatalogTranslation(
    id: string,
    language: string,
    value: string
  ): Promise<{ response?: CatalogValueTranslation; error?: any }> {
    return httpApiApplication
      .put(`${baseCatalogUrl}/${id}/translations/${encodeURIComponent(language)}`, { value })
      .then((response) => ({ response: response as CatalogValueTranslation }))
      .catch((error) => ({ error }));
  }
}
export default new CatalogService();
